import { AdminOrderItemComponent } from './admin-order-item-component';
import { AdminOrderShipmentComponentGroupType } from '../enums/admin-order-shipment-component-group-type';

export class AdminOrderShipmentComponentGroup {
  public constructor(
    private readonly data: {
      name: string;
      type: AdminOrderShipmentComponentGroupType;
      components: AdminOrderItemComponent[];
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get type(): AdminOrderShipmentComponentGroupType {
    return this.data.type;
  }

  public get components(): AdminOrderItemComponent[] {
    return this.data.components;
  }
}
